<div class="modal-header" [ngClass]="{'-border-bottom': borderBottom}">
    <div class="modal-header__inner">
        <ng-content></ng-content>
    </div>
</div>